<template>
     
   <v-layout row pb-2>

      <Menu  />  <!-- Menu -->
      <v-dialog
        width="400">        
      </v-dialog>
      <v-flex xs12>
        <v-flex xs12>
          <v-container grid-list-xl>
            <span class="headline" data-v-step="0" style="margin-left:20px;" >Documents</span>
              <v-layout wrap>
                <v-flex class="d-flex"
                  color="grey lighten-3"
                  xs12 sm6 md6 offset-sm1 offset-md2>
                  <v-flex xs12>


                    <div ref="div"   style="min-height:100px;height:auto;">

                      <v-layout >
                        <v-flex style="margin-top:40px;">
                            <h2 v-if="verifyFiles[0]" style="color:black;margin:100px 50px 0 10px;">FILE DETAILS</h2>
                            <h2 v-else style="letter-spacing:1.2px;color:black;margin:200px 0px 0 10px">VALIDATE FILES NOW</h2>

                            
                            <!-- <a href="https://telos.eosx.io/account/sptoken22325" target="_blank"><h5 style="color:#FF5B4A;margin:50px 50px 0 20px; ">Live on a public blockchain</h5></a> -->
                        </v-flex>
                      </v-layout>
                      <v-layout d-flex v-if="!verifyFiles[0]" ref="input">
                        <v-flex>
                          <label style="display:block; " >
                              <v-flex style="width:80%; padding:60px;margin-top:40px;margin-left:10px; border: 3px dashed rgba(255,255,255,0.8);" offset-xs1>
                              
                                  <strong style="font-size:18px;color:black" v-if="progress === 0">
                                  {{ label }} 
                                  <svg style="fill:black" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
                                  </strong>
                                  <strong v-if="progress > 0 && progress < 100"> {{ progress }}%</strong>
                                  <span style="font-size:18px;color:black"  v-else>{{ name }}</span>
                                  <input  type="file" :accept="accept" @change="onFileChange"/>
                              

                                  <svg style="fill:black; margin-top:-10px; margin-left:10px;"  v-if="progress === 100" @click="removeFile" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
                                      <path d="M0 0h24v24H0z" fill="none"></path>
                                  </svg>
                                  <pre>{{ error }}</pre>
                              
                              </v-flex>
                            </label>
                        </v-flex>
                    
                              <v-flex style="margin-top:-53px;">
                                <h2 style="color:black; margin-top:40px;">EXAMPLE FILE</h2>
                                <!-- <a :href="validFile" download="validFile">Valid file</a> -->
                                <a style="margin-left:0px;" :href="invalidFile" download="invalid_file">Download tampered PDF file</a>
                              </v-flex>
                          
                      </v-layout>


                      

                      <v-layout v-if="!verifyFiles[0]" ref="input">
                        <label style="display:block; " >
                            <v-flex style="width:100%; padding:60px;margin-top:40px;margin-left:10px; border: 3px dashed rgba(255,255,255,0.8);" offset-xs1>
                            
                                <strong style="font-size:18px;color:black" v-if="progress === 0">
                                {{ label }} Upload
                                <svg style="fill:black" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
                                </strong>
                                <strong v-if="progress > 0 && progress < 100"> {{ progress }}%</strong>
                                <span style="font-size:18px;color:black"  v-else>{{ name }}</span>
                                <input  type="file" :accept="accept" @change="onFileChangeUpload"/>
                            

                                <svg style="fill:black; margin-top:-10px; margin-left:10px;"  v-if="progress === 100" @click="removeFile" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
                                    <path d="M0 0h24v24H0z" fill="none"></path>
                                </svg>
                                <pre>{{ error }}</pre>
                            
                            </v-flex>
                        </label>
                      </v-layout> 

                      <!--

                      <v-flex xs8>
                          <span style="" v-for="file in verifyFiles" :key="file.originalname">
                          <table style="  width:100%">
                              <tr style="border:1px solid white; text-align:left; ">
                              <th>Certificate id</th>
                              <th>Valid signature</th>
                              <th>Line content</th>
                              <th>Uploaded signature</th>
                              <th>Match</th>
                              </tr>
                              <tr style="font-size:30px;text-align:left" v-bind:class="[lines.invalidData ? redBorder : '']" v-for="lines in file">
                              <td style="">{{lines.certificateId}}</td>
                              <td v-if="lines.lineSignature">{{(lines.lineSignature).substr(0,6)}}</td>
                              <td v-else="lines.lineSignature">none</td>
                              <td v-if="lines.uploadedPdfLine && lines.uploadedPdfLine.length > 40">{{lines.uploadedPdfLine.substr(0,40)}} ...</td>
                              <td v-else-if="lines.uploadedPdfLine">{{lines.uploadedPdfLine.substr(0,40)}}</td>
                              <td style="color:red" v-else-if="lines.invalidData">{{lines.invalidData}}</td>
                              <td v-if="lines.uploadedPdfLineSignature">{{(lines.uploadedPdfLineSignature).substr(0,6)}}</td>
                              <td v-else>{{(lines.uploadedPdfLineSignature)}}</td>
                              <td style="background-color:green" v-if="lines.lineSignature == lines.uploadedPdfLineSignature"></td>
                              <td style="background-color:red" v-else></td>
                              </tr>
                          </table>
                          </span>
                        </v-flex>
                      -->
                      <v-layout d-flex style="margin-top:100px;height:auto; color:black; "   class="content">
                        <v-flex  d-flex xs2>
                          <span style="" v-for="file in verifyFiles" :key="file.originalname">
                          <table style="  width:100%">
                              <tr style="border:1px solid black; text-align:left; ">
                              <th>Valid signature</th>
                              </tr>
                              <tr  style="opacity:0.5;font-size:14px;line-height:34px;text-align:left" v-bind:class="[lines.invalidData ? redBorder : '']" v-for="lines in file">
                            
                              <td v-if="lines.lineSignature">{{(lines.lineSignature).substr(0,6)}}</td>
                              <td v-else="lines.lineSignature">none</td>
                              </tr>
                          </table>
                          </span>
                        </v-flex>

                        <v-flex v-if="verifyFiles[0]" style="background-color:black;  color:black; padding:10px;" xs7>
                          <span  v-for="file in verifyFiles" :key="file.originalname">
                          <table style="  width:100%">
                              <tr style="border:1px solid black; text-align:left; ">
                              <th>File content</th>
                              </tr>
                              <tr style="font-size:22px;text-align:left" v-bind:class="[lines.invalidData ? redBorder : '']" v-for="lines in file">
                              <td v-if="lines.uploadedPdfLine && lines.uploadedPdfLine.length > 60">{{lines.uploadedPdfLine.substr(0,60)}} ...</td>
                              <td v-else-if="lines.uploadedPdfLine">{{lines.uploadedPdfLine}}</td>
                              <td style="color:red" v-else-if="lines.invalidData">{{lines.invalidData}}</td>
                              </tr>
                          </table>
                          </span>
                        </v-flex>

                        <v-flex xs2 offset-xs1>
                          <span style="" v-for="file in verifyFiles" :key="file.originalname">
                          <table style="  width:100%">
                              <tr style="border:1px solid black; text-align:left; ">
                              <th style="color:rgb(56, 63, 134)">Uploaded</th>
                              <th>Match</th>
                              </tr>
                              <tr style="font-size:14px;line-height:34px;text-align:left" v-bind:class="[lines.invalidData ? redBorder : '']" v-for="lines in file">
                                <td style="opacity:0.5; color: rgb(56, 63, 134)" v-if="lines.uploadedPdfLineSignature">{{(lines.uploadedPdfLineSignature).substr(0,6)}}</td>
                                <td v-else>{{lines.uploadedPdfLineSignature}}<div style="margin:16px 0 16px -180px;height:1px;100%;background-color:black;"></div></td>
                                <td v-if="lines.lineSignature == lines.uploadedPdfLineSignature"><div style="border-radius:10px;height:15px;width:15px;background-color:green"></div></td>
                                <td v-else><div style="border-radius:10px;height:15px;width:15px;background-color:red"></div></td>
                              </tr>
                          </table>
                          </span>
                        </v-flex>
                    </v-layout>
                      
                    </div>


                  </v-flex>
                </v-flex>
              </v-layout>
          </v-container>
        </v-flex>
      </v-flex>
    </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import store from "@/store"
import router from "@/router"

import Menu  from '../../components/Menu' 

export default {
    components: {
      Menu
    },
  props: {
    label: {
      type: String,
      default: 'Drag or Drop files here'
    },
    accept: {
      type: String,
      default: '*' // image/png, image/jpeg, application/pdf, application/vnd.ms-excel
    }
  },
  data () {
    return {
      offsetTop: 0,

      file: null,
      name: null,
      progress: 0,
      error: null,
      dragAndDropCapable: true,
      verifyFiles: [],
    }
  },
  mounted () {
    const { div } = this.$refs
    // Determine if drag and drop functionality is capable in the browser
    this.dragAndDropCapable = this.isDragAndDropCapable()
    if(this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( event => {
        document.body.addEventListener(event, e => {
          e.preventDefault()
          e.stopPropagation()
          // if (e.type === 'dragover') {
          //   console.log('dragover', div) // eslint-disable-line
          //   div.classList.add('dragover')
          // }
        })
      })
      div.addEventListener('drop', e => {
        
        this.onFileChange(e)
      })
    }
  },
  computed: {
 
  },
  methods: {
      async sendFileForValidation(file) {
        // const file = this.$refs.verifyFile.files[0]
        console.log(file)
        // file = file[0]

        const formData = new FormData();
        formData.append('file', file)
        try {
          this.uploading = true;
          const res = await this.$store.dispatch('smartcheck/verifyDocuments', formData)
          console.log(res)
          this.verifyFiles.push(res.data.data[0]);

          this.uploading = false;
        } catch(err) {
          console.log(err)
          this.error = false;
          this.uploading = false;
        }
      },
       async sendFileForUpload(file) {
        // const file = this.$refs.verifyFile.files[0]
        console.log(file)
        // file = file[0]

        const formData = new FormData();
        formData.append('file', file)
        try {
          this.uploading = true;
          const res = await this.$store.dispatch('smartcheck/uploadDocuments', formData)
          console.log(res)
          this.verifyFiles.push(res.data.data);

          this.uploading = false;
        } catch(err) {
          console.log(err)
          this.error = false;
          this.uploading = false;
        }
      },
    
    isDragAndDropCapable () {
      const { div } = this.$refs
      return (('draggable' in div)
        || ('ondragstart' in div && 'ondrop' in div))
        && 'FormData' in window
        && 'FileReader' in window
    },
    onFileChange(e) {
      // e.preventDefault()
      const files = e.target.files || e.dataTransfer.files
       if (!files.length)
         return
       this.createFile(files[0])
       this.sendFileForValidation(files[0])
     },
     onFileChangeUpload(e) {
      // e.preventDefault()
      const files = e.target.files || e.dataTransfer.files
       if (!files.length)
         return
       this.createFile(files[0])
       this.sendFileForUpload(files[0])
     },
     createFile(file) {
      const reader = new FileReader()
      const vm = this
      reader.onprogress = e => {
        if (e.lengthComputable) {
          vm.trackProgress(e.loaded, e.total)
        }
      }
      reader.onloadend = e => {
        const { error } = e.target
        if (error != null) {
          switch (error.code) {
            case error.ENCODING_ERR:
              vm.error = 'Encoding error!'
              break
            case error.NOT_FOUND_ERR:
              vm.error = 'File not found!'
              break
            case error.NOT_READABLE_ERR:
              vm.error = 'File could not be read!'
              break
            case error.SECURITY_ERR:
              vm.error = 'Security issue with file!'
              break
            default:
              vm.error = 'I have no idea what\'s wrong!'
          }
        }
        vm.trackProgress(e.loaded, e.total)
      }
      reader.onload = e => {
        const { result } = e.target
        vm.file = result
        // this.$emit('load', result)
        vm.name = file.name

        
      }
      reader.readAsBinaryString(file)
    },
    trackProgress (loaded, total) {
      this.progress = parseInt(((loaded / total) * 100), 10)
    },
    removeFile () {
      this.progress = 0
      this.file = ''
      this.name = null
      // this.$emit('load', null)
    }
  }
}
</script>

<style scoped>
input[type="file"] {
  display: none;
}
strong,
svg {
  vertical-align: middle;
}

table#t01 tr:nth-child(even) {
  background-color: #eee;
}
table#t01 tr:nth-child(odd) {
  background-color: #fff;
}
table#t01 th {
  color: white;
  background-color: black;
}

  .dropzone {
    min-height: 200px;
    padding: 10px 10px;
    position: relative;
    cursor:pointer;
    outline: 1px solid gray;
    outline-offset: -10px;
    background: lightcyan;
  }

  .dropzone:hover{
    background:lightblue;
  }

  .input-file {
    opacity: 0;
    width:100%;
    height:200px;
    position: absolute;
    cursor:pointer;

  }

  .dropzone .call-to-action {
    font-size: 1.2rem;
    text-align: center;
    padding: 70px 0;
  }
  
  
</style>
